import { PairLayout } from 'components/explorer/pairs/PairLayout';

export const PorfolioPairsPage = () => {
  return <PairLayout url="/portfolio/pairs" />;
};
